// Dates as accounting reads them: MM/DD/YYYY.

const pad = (n: number) => String(n).padStart(2, "0");

// "2026-10-29" -> "10/29/2026". A plain date is read as written, never shifted
// through the browser's time zone (new Date("2026-10-29") is UTC midnight,
// which is the 28th in Texas).
export function formatDate(value: string | null | undefined): string {
  if (!value) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (m && value.length === 10) return `${m[2]}/${m[3]}/${m[1]}`;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
}

// A timestamp in local time: "10/29/2026 2:05 PM".
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return `${formatDate(value)} ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
}
